import { render, staticRenderFns } from "./PaymentByCard.vue?vue&type=template&id=c5296d38"
import script from "./PaymentByCard.vue?vue&type=script&lang=js"
export * from "./PaymentByCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports